import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatChipsModule,
  MatIconModule,
  MatInputModule,
  MatFormFieldModule,
  MatProgressBarModule
} from "@angular/material";
import {
  NgbAccordionModule,
  NgbDropdownModule,
  NgbTooltipModule
} from "@ng-bootstrap/ng-bootstrap";

import { SharedPipesModule } from "../pipes/shared-pipes.module";

import { InputNameDirective, PhoneNumberDirective, CapitalizeFirstLetterDirective } from "./../directives";

import { SharedComponentsModule } from "./../components";
import { AutoTabDirective } from "../directives/auto-tab.directive";
import { NumbersOnlyDirective } from "../directives/numbers-only.directive";
import { SessionService } from "app/shared/services/session";
import { EqualValidator } from "../validators/equal-validator.directive";
import { NgxPaginationModule } from "ngx-pagination";
import { PreviousRouteService } from "../services/previous-route";
import { DobDirective } from "../directives/dob.directive";
import { AutofocusDirective } from "../directives/autofocus.directive";
import { SystemService } from "../services/system/system.service";
import {RaceService, FeatureFlagService} from "../services";

@NgModule({
  imports: [
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    SharedPipesModule
  ],
  exports: [
    // Modules
    CommonModule,
    SharedComponentsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDropdownModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule,
    MatInputModule,
    MatFormFieldModule,
    MatChipsModule,
    NgbAccordionModule,
    NgbTooltipModule,
    SharedPipesModule,
    NgxPaginationModule,
    // Directives
    InputNameDirective,
    PhoneNumberDirective,
    CapitalizeFirstLetterDirective,
    DobDirective,
    AutoTabDirective,
    NumbersOnlyDirective,
    AutofocusDirective,
    // Pipes
    EqualValidator
  ],
  declarations: [
    PhoneNumberDirective,
    InputNameDirective,
    CapitalizeFirstLetterDirective,
    DobDirective,
    AutoTabDirective,
    NumbersOnlyDirective,
    AutofocusDirective,
    EqualValidator
  ],
  providers: [SessionService, PreviousRouteService, SystemService, RaceService, FeatureFlagService]
})
export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/shared/modules/shared.module.ts